import React, { Fragment } from 'react';
import ProductCard from './ProductCard';
import SliderContainer from '../../SliderContainer';

const ProductSlider = ({ products, slideCount = 4 }) => {
  const showMore = products && products.length > slideCount;
  return (
    <SliderContainer
      showMore={showMore}
      slideCount= {slideCount}
      sliderItem={<ProductSliderItem products={products} />}
    />
  );
};

const ProductSliderItem = ({ products }) => {
  return (
    <Fragment>
      {products.map((productItem, index) => {
        return (
          <div
            key={"product-list-" + index}
            className="category-slider__list--item"
          >
            <ProductCard productItem={productItem} index={index} />
          </div>
        );
      })}
    </Fragment>
  );
};
export default ProductSlider;
